import { takeLatest } from 'redux-saga/effects';

import { INVITE_USER_SUCCESS } from 'containers/DialogInviteUser/constants';
import { RESEND_USER_INVITES_SUCCESS } from 'containers/DialogUserInvitationsInfo/constants';

import sagaRelayInvalidateData from './sagaRelayInvalidateData';

function* sagaInvalidateStore() {
  yield sagaRelayInvalidateData('GroupInvite');
}

export default function* sagaWatchersGroupInvite() {
  // Invalidate data on Relay store and refetch queries
  yield takeLatest(INVITE_USER_SUCCESS, sagaInvalidateStore);
  yield takeLatest(RESEND_USER_INVITES_SUCCESS, sagaInvalidateStore);
}
